export default __webpack_public_path__ + "static/media/icon-back.fadcfc8a.svg";